import firebase from 'firebase/app'
import {db} from '@/firebase'
import { store } from '@/store'
import EventEmitter from 'events'

class OfficeRepository extends EventEmitter {

    async uncertifiedIds () {
        const results = []
        const querySnapshot = await db.collection('offices').where('isDoctorCertified', '==', false).get()

        querySnapshot.forEach((doc) => {
            results.push(doc.id)
        })

        return results
    }

    allNearby (position, type, onSuccess, onError) {
        db.collection('offices')
            .where('doctorType', '==', type)
            .where('isDoctorCertified', '==', true)
            .get()
            .then((querySnapshot) => {
                let offices = {}
                let distance

                querySnapshot.forEach((doc) => {
                    var data = doc.data()

                    if (data.location) {
                        // Only offices in a 30km radius
                        distance = window.distanceBetween(data.location._lat, data.location._long, position._lat, position._long)
                        if (distance <= 30) {
                            data['distance'] = distance
                            offices[doc.id] = data
                        }
                    }
                });

                onSuccess(offices)
            })
            .catch((error) => {
                onError(error)
            })
    }

    find (id, onSuccess, onError) {
        db.collection('offices')
            .doc(id)
            .get()
            .then((doc) => {
                if (doc.exists) {
                    onSuccess(doc.data())
                } else {
                    onError({error: "Office was not found"})
                }
            })
            .catch((error) => {
                onError(error)
            })
    }

    getAll (onSuccess, onError) {
        db.collection('offices')
            .get()
            .then((querySnapshot) => {
                let data = []
                querySnapshot.forEach(doc => {
                    data.push(doc.data())
                }) 
                onSuccess(data)
            })
            .catch((error) => {
                onError(error)
            })
    }

}

export default new OfficeRepository()



// WEBPACK FOOTER //
// ./src/data/OfficeRepository.js